import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';

interface MediaPreviewModalsProps {
  imagePreview: { open: boolean; url: string; alt: string };
  documentPreview: { open: boolean; url: string; fileName: string };
  onCloseImagePreview: () => void;
  onCloseDocumentPreview: () => void;
}

export const MediaPreviewModals: React.FC<MediaPreviewModalsProps> = ({
  imagePreview,
  documentPreview,
  onCloseImagePreview,
  onCloseDocumentPreview,
}) => {
  const theme = useTheme();

  return (
    <>
      {/* Image Preview Modal */}
      <Dialog
        open={imagePreview.open}
        onClose={onCloseImagePreview}
        maxWidth={false}
        sx={{
          '& .MuiDialog-paper': {
            bgcolor: 'transparent',
            boxShadow: 'none',
            maxWidth: '90vw',
            maxHeight: '90vh',
          },
        }}
      >
        <DialogContent sx={{ p: 0, position: 'relative' }}>
          <Box
            component="img"
            src={imagePreview.url}
            alt={imagePreview.alt}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              maxWidth: '90vw',
              maxHeight: '90vh',
            }}
          />
        </DialogContent>
        <DialogActions sx={{ position: 'absolute', top: 8, right: 8, p: 0 }}>
          <IconButton
            onClick={onCloseImagePreview}
            sx={{
              bgcolor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(0, 0, 0, 0.7)',
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/* Document Preview Modal */}
      <Dialog
        open={documentPreview.open}
        onClose={onCloseDocumentPreview}
        maxWidth="lg"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            height: '90vh',
          },
        }}
      >
        <DialogActions sx={{ p: 1, borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography variant="h6" sx={{ flex: 1, pl: 1 }}>
            {documentPreview.fileName}
          </Typography>
          <IconButton onClick={onCloseDocumentPreview}>
            <Close />
          </IconButton>
        </DialogActions>
        <DialogContent sx={{ p: 0, height: 'calc(100% - 64px)' }}>
          <Box
            component="iframe"
            src={documentPreview.url}
            sx={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title={documentPreview.fileName}
            onError={(e) => {
              console.error('Error loading document preview:', e);
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};